import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  updateWorkerAction,
  createWorkerAction,
  fetchWorkersAction,
} from "../../store/worker/workerThunk";
import { ImSpinner8 } from "react-icons/im";

function WorkerModal({ isOpen, toggle, onSubmit, editMode, chatbot }) {
  const [Name, setName] = useState("");
  const [Behaviour, setBehaviour] = useState("");
  const [BotType, setBotType] = useState("");
  const [Status, setStatus] = useState("Inactive");
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (editMode && chatbot) {
      setName(chatbot.name);
      setBehaviour(chatbot.behaviour);
      setBotType(chatbot.bot_type || "");
    } else {
      setName("");
      setBehaviour("");
      setBotType("");
    }
  }, [editMode, chatbot]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);

    const onComplete = () => {
      dispatch(fetchWorkersAction());
      setLoader(false);
      toggle(); // Close modal after successful action
    };

    const onError = (error) => {
      console.error(error);
      setLoader(false);
    };

    if (editMode) {
      dispatch(
        updateWorkerAction({
          Id: chatbot.id,
          Name,
          Behaviour,
          BotType,
          Status: chatbot.status,
          onSuccess: onComplete,
          onError,
        })
      );
    } else {
      dispatch(
        createWorkerAction({
          Name,
          Behaviour,
          BotType,
          onSuccess: onComplete,
          onError,
        })
      );
    }
    setName("");
    setBehaviour("");
    setBotType("");
  };

  if (!isOpen) return null;
  return (
    <form onSubmit={handleSubmit}>
      <div className="modal-overlay">
        <div className="modal-backdrop" onClick={toggle}></div>
        <div className="modal-container">
          <div className="modal-header">
            <h2 className="modal-title">
              {editMode ? "Edit Chatbot" : "Add Chatbot"}
            </h2>
            <button onClick={toggle} className="cross_modal">
              &times;
            </button>
          </div>
          <div className="modal-body">
            <label>
              Chatbot Name:
              <input
                type="text"
                value={Name}
                required
                onChange={(e) => setName(e.target.value)}
              />
            </label>
            <label>
              Bot Type:
              <input
                type="text"
                value={BotType}
                required
                onChange={(e) => setBotType(e.target.value)}
              />
            </label>
            <label>
              Behaviour
              <textarea
                value={Behaviour}
                required
                onChange={(e) => setBehaviour(e.target.value)}
              />
            </label>
          </div>
          <div className="modal-footer">
            <button type="submit" className="button_worker" disabled={loader}>
              {loader ? (
                <ImSpinner8 className="spinning-icon animate-spin" />
              ) : editMode ? (
                "Save Changes"
              ) : (
                "Add Chatbot"
              )}
            </button>
            <button
              onClick={toggle}
              type="button"
              className="modal-close-button"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}

export default WorkerModal;
